"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertByteArrayToHexString = (bytes, uppercase = false) => {
    const hex = [];
    for (const byte of bytes) {
        hex.push((byte >>> 4).toString(16));
        hex.push((byte & 0xF).toString(16));
    }
    return uppercase ? hex.join('').toUpperCase() : hex.join('');
};
//# sourceMappingURL=convertByteArrayToHexString.js.map